"use strict";
/*
 * Created on 18. 2. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * <p>
 * Mail event that can be stored.
 * </p>
 *
 * @author Radek Beran
 */


var MailEvent =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(MailEvent, _DomainObject_1$Domai);

  function MailEvent(id, entityId, eventType, subject, to, sent) {
    var _this;

    _classCallCheck(this, MailEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MailEvent).call(this));
    _this.id = id;
    _this.entityId = entityId;
    _this.eventType = eventType;
    _this.subject = subject;
    _this.to = to;
    _this.sent = sent;
    return _this;
  }

  return MailEvent;
}(DomainObject_1.DomainObject);

exports.MailEvent = MailEvent;

MailEvent.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(MailEvent.name);
  return {
    id: builder.id('id'),
    entityId: builder.str('entityId'),
    eventType: builder.str('eventType'),
    subject: builder.str('subject'),
    to: builder.listOf(builder.str('to')),
    sent: builder.date('sent', DateParser_1.DateParser.ISO_PATTERN)
  };
}();